import React, { Component, useState } from "react";
import ReactDOM from "react-dom";
// import Modal, { useModalState } from "react-simple-modal-provider";
import { IoMdClose } from "react-icons/io";
import { MdUnfoldMore } from "react-icons/md";
import "./style.scss";
import { Label, Preloader, Text } from "pctComponents/atoms";
import { useFetch } from "pctHooks/useFetch";
import { convertToBrDate, getProfileInfo } from "../../../services/utils";
import { userEnrollments } from "../../../services/api";
import { Link, useLocation, BrowserRouter as Router } from "react-router-dom";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useHistory } from "react-router-dom";
import parse from 'html-react-parser';

type Props = {
  obj: any;
};

const ModalLoadingInfo = NiceModal.create(({ obj }: Props) => {
  const history = useHistory();
  const modal = useModal();
  let timerHandle: any;

  const {
    message,
    content,
    closeBtn,
    closeBtnFn,
    loadding,
    verificationFunction,
    verificationInterval,
    className
  } = obj;

  if (verificationFunction) {
    timerHandle = setInterval(
      function () {
        verificationFunction().then((response) => {
          if (response === true) {
            if (timerHandle) clearInterval(timerHandle);
            modal.remove();
          }
        });
      }.bind(this),
      verificationInterval
    );
  }

  return (
    <div className={`modalLoadingInfo ${((className)? className : '')}`}>
      <div className="modal-body-pct">
        

        {message && <h4>{ parse(`${message}`) }</h4>}
        {loadding && <div className="preloaderIt"></div>}

        

        {content && content()}

        {closeBtn && (
          <button className="closeBtn" onClick={() => {
            
            if(timerHandle){
              clearInterval(timerHandle);
            }

            if(closeBtnFn) closeBtnFn();

            modal.remove();
          }}>
            <IoMdClose />
          </button>
        )}

          <div className="bottonLine"></div>
      </div>
    </div>
  );
});

export default ModalLoadingInfo;
